<template>
    <div class="system-message">
		<div class="message-item " v-for="item in messages" :key="item.id" @click="item.url">
            <div class="datetime">
                {{item.send_at}}
            </div>
            <div class="content">
                <div class="image" v-if="item.banner">
                    <img :src="item.banner">
                </div>
                <div class="title">
                    <p>{{item.title}}</p>
                </div>
                <div class="subtitle">
                    <p>{{item.des}}</p>
                </div>
            </div>
		</div>
    </div>
</template>
<script>
import {SystemNotice,PersoanalUserInfo,UserRead} from '../../../config/interface.js'
	export default{
		
		data(){
			return{
				userInfo:'',  //用户信息
                messages:[]
			}
		},
		watch:{
			
		},
        created(){
            if(common.is_weixin()){
                //微信端
				this.getUserInfo();
			}else{
                //非微信端
				this.userInfo=this.$store.state.userInfo;
                if(this.userInfo){

                }
                else{
                    this.$router.replace({
                        path:'/vascularNews/user/login',
                        query:{url:window.location.href}
                    })	
                }
			}
        },
		mounted(){
		},
		methods:{
            //得到用户信息
            getUserInfo(){
                const url=PersoanalUserInfo;
                let params={};
                const method='POST';
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        let data=res.data;
                        localStorage.setItem('userInfo',JSON.stringify(data));
                        this.$store.dispatch('storageUserInfo',data);	
                        this.userInfo=data;
                        if(this.userInfo&&this.userInfo.mobile_status==1){
                            this.getSystemMessage();
                        }
                        else{
                            common.toast('未绑定手机',1000,'fail',()=>{
                                 this.$router.replace({
                                    path:'/vascularNews/user/login',
                                    query:{url:window.location.href}
                            })
					        })	
                        }
                    }
                })
            },
            getSystemMessage(){
				const url=SystemNotice;
				const method='POST'
				let params={};
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						this.messages=res.data.data;
                        this.setHasRead();
					}
				})
			},
            setHasRead(){
                const url=UserRead;
				const method='POST'
				let params={
                    type:0
                };
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
					}
				})
            }
			
		}
		
	}
</script>
<style lang="scss">
.system-message{
    margin:0 10px 20px 10px;
    .datetime{
        text-align: center;
        height: 40px;
        line-height: 40px;
        color: rgb(170, 163, 163);
    }
    .content{
        background: white;
        border-radius: 0.3rem;
        padding:15px;
        .title{
            font-size:16px;
        }
        .subtitle{
            color: #666666;
            font-size:14px;
            margin-top: 10px;
        }
        img{
            width:100%;
            height: 160px;
        }
       
    }
	
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Message/SystemMessage.vue